'use strict';

angular.module('amexReconciliationApp')
  .service('AdditionalTransactionDataRepository', function ($resource, $http) {
    var self = this;
    var additionalTransactionDataResource =
      $resource('/api/v1/transactions/:transactionId/additionalTransactionData');

    self.findAdditionalTransactionData = function findAdditionalTransactionData(transaction) {
      return additionalTransactionDataResource
        .query({ transactionId: transaction.id })
        .$promise
        .then(function (response){
          if (response.length > 0) {
            return response[0];
          }
          return {};
        })
        .catch(function () {
          return {};
        });
    };

    self.updateAdditionalData = function (additionalData) {
      return $http.patch('/api/v1/additionalTransactionDatas', additionalData);
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/AdditionalTransactionDataRepository.js
// module id = 600
// module chunks = 0